export { PremiumFaq as TwoColumnFaq } from "../conversion-sections"
export type { PremiumFaqProps as TwoColumnFaqProps } from "../conversion-sections"